import React, { PureComponent, PropTypes } from 'react'

export default class List extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    pageCount: PropTypes.number,
    renderItem: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
    onLoadMoreClick: PropTypes.func,
    nextPageUrl: PropTypes.string
  };

  static defaultProps = {
    isFetching: true,
  };

  renderLoadMore() {
    const { isFetching, onLoadMoreClick } = this.props
    if (!onLoadMoreClick) {
      return null;
    }

    return (
      <div className="col-12 text-center mb-3">
        <button className="btn btn-outline-success" onClick={onLoadMoreClick} disabled={isFetching}>
          {isFetching ? 'Ielāde...' : 'Ielādēt vecākas aktualitātes'}
        </button>
      </div>
    )
  }

  render() {
    const {
      isFetching, nextPageUrl, pageCount, items, renderItem } = this.props

    const isEmpty = items.length === 0
    if (isEmpty && isFetching) {
      return <h2>Ielāde...</h2>
    }

    const isLastPage = !nextPageUrl
    if (isEmpty && isLastPage) {
      return <h1>Te nekā nav.</h1>
    }

    const { className } = this.props;

    return (
      <div className={className}>
        {items.map(renderItem)}
        {pageCount > 0 && !isLastPage && this.renderLoadMore()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/List.js